'use strict';

angular.module('ClinicApp').config(function($stateProvider, authorizationProvider) {
  $stateProvider.state('forgot-password', {
    url: '/forgot-password/?email',
    templateUrl: '/views/forgot-password.html',
    controller: 'ForgotPasswordCtrl',
    resolve: {
      pageTitle: function($pageTitle) {
        $pageTitle.set('Forgot Password - Opencare');
      },
      auth: authorizationProvider.requireUnauthorizedUser,
    },
    data: {
      hideNavigation: true,
    },
  });
});

angular.module('ClinicApp').controller('ForgotPasswordCtrl', function($scope, $stateParams, GrowlService, UserService) {
  $scope.email = $stateParams.email;

  $scope.submit = function() {
    return UserService.requestResetPassword($scope.email).then(function() {
      GrowlService.success('Your password reset email has been successfully sent. Please check your inbox.');
    });
  };
});
